<template>
<div class="test-from-editor protected-content" v-on="protectionEvents">
  <div
    class="question__title l-height-normal mb-6"
    :class="{'question__compact': questionHtml.length>200}"
    v-html="questionHtml"
  />
  <div class="col-12 d-flex gap-8 font-weight-600">
    <div class="col-7 pa-0 d-flex align-center">
      Ответ
    </div>
    <div class="col-5 pa-0">
      <div class="col-12 d-flex pa-0">
        <div class="col-5 pa-0 d-flex justify-center text-center">Сделаю</div>
        <div class="col-5 pa-0 d-flex justify-center text-center">Не сделаю</div>
      </div>
    </div>

  </div>
  <v-list
    :class="['d-flex flex-column gap-3 pb-5']"
  >
    <v-list-item
      v-for="answer in answerOptions"
      :key="answer.id"
      :class="[
        {
          'suitable-selected': isSelectedAsSuitable(answer.id),
          'unsuitable-selected': isSelectedAsUnsuitable(answer.id),

        },
        'col-12 gap-4 list-item',
      ]"
    >
      <v-list-item-content :class="['col-7 pa-0']">
        <v-list-item-title>{{ answer.text }}</v-list-item-title>
      </v-list-item-content>

      <v-list-item-action :class="['col-5 pa-0']">
        <v-radio-group
          :value="selectedType[answer.id]"
          row
          hide-details
          class="col-12 pa-0"
        >
          <v-radio
            value="suitable"
            @click="onSelectSuitable(answer)"
            :disabled="isDisabled(answer.id, 'suitable')"
            class="col-5 ma-0 pa-0 d-flex justify-center"
          ></v-radio>
          <v-radio
            value="unsuitable"
            @click="onSelectUnsuitable(answer)"
            :disabled="isDisabled(answer.id, 'unsuitable')"
            class="col-5 ma-0 pa-0 d-flex justify-center"
          ></v-radio>
        </v-radio-group>
      </v-list-item-action>
    </v-list-item>
  </v-list>
  <slot name="feedback"/>

  <div class="d-flex justify-space-between align-center mt-10">
    <form @submit.prevent="resetSelection" >
      <v-btn
        class="btn-disabled-primary mb-4 mx-auto"
        type="submit"

        color="error"
        :disabled="!answeredCount"
        :loading="loading">
        Сбросить
      </v-btn>
    </form>
    <form @submit.prevent="submitAnswers" >
      <v-btn
        class="btn-disabled-primary mb-4 mx-auto"
        type="submit"
        x-large
        color="primary"
        :disabled="!isValidSelection"
        :loading="loading">
        Продолжить
      </v-btn>
    </form>
  </div>
</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Vue from 'vue';

export default {
  name: 'TestSimpleQuestion',

  data() {
    return {
      // ['suitable', 'unsuitable']
      selectedType: {},
      validationError: null,

      protectionEvents: {
        copy: this.preventCopy,
        cut: this.preventCopy,
        contextmenu: this.preventContextMenu,
        selectstart: this.preventSelect
      }
    };
  },

  computed: {
    ...mapGetters({
      testData: 'testing/testing/testData',
      loading: 'testing/testing/loading',
      selectedAnswer: 'testing/testing/selectedAnswer',
      feedBackText: 'testing/testing/feedBackText',
    }),

    questionHtml() {
      return this.testData?.question?.text || '';
    },
    answerOptions() {
      return this.testData?.answer_options || [];
    },
    suitableCount() {
      return Object.values(this.selectedType).filter(type => type === 'suitable').length;
    },
    unsuitableCount() {
      return Object.values(this.selectedType).filter(type => type === 'unsuitable').length;
    },
    suitableAnswers() {
      return Object.entries(this.selectedType)
        .filter(([, value]) => value === 'suitable')
        .map(([key]) => key);
    },
    unsuitableAnswers() {
      return Object.entries(this.selectedType)
        .filter(([, value]) => value === 'unsuitable')
        .map(([key]) => key);
    },
    answeredCount() {
      return Object.keys(this.selectedType).length;
    },
    isAllAnswersSelected() {
      return this.answeredCount === this.answerOptions.length;
    },

    isFeedBackRequired() {
      return this.testData.is_feedback_available ? this.feedBackText.length > 3 : true;
    },
    isValidSelection() {
      return this.suitableCount === 2 && this.unsuitableCount === 1 && this.isFeedBackRequired;
    },
    selectionStatus() {
      if (!this.isAllAnswersSelected) {
        const remaining = this.answerOptions.length - this.answeredCount;
        return {
          type: 'info',
          message: `Осталось выбрать ${remaining} вариант(а). Нужно выбрать 2 подходящих и 1 неподходящий.`
        };
      }

      if (this.suitableCount !== 2) {
        return {
          type: 'warning',
          message: `Выбрано ${this.suitableCount} подходящих вариантов. Нужно выбрать ровно 2.`
        };
      }

      if (this.unsuitableCount !== 1) {
        return {
          type: 'warning',
          message: `Выбрано ${this.unsuitableCount} неподходящих вариантов. Нужно выбрать ровно 1.`
        };
      }

      return {
        type: 'success',
        message: '✓ Все ответы выбраны правильно!'
      };
    },
  },

  watch: {
    testData: {
      handler() {
        this.resetSelection();
      },
      immediate: true
    }
  },

  methods: {
    ...mapActions({
      sendAnswer: 'testing/testing/sendPositiveNegativeAnswer',
      setSelectedAnswer: 'testing/testing/setSelectedAnswer',
    }),
    isSelectedAsSuitable(answerId) {
      return this.selectedType[answerId] === 'suitable';
    },
    isSelectedAsUnsuitable(answerId) {
      return this.selectedType[answerId] === 'unsuitable';
    },
    isDisabled(answerId, type) {
      const currentType = this.selectedType[answerId];
      if (currentType && currentType !== type) return true;
      if (currentType === type) return false;
      if (type === 'suitable' && this.suitableCount >= 2 && currentType !== 'suitable') {
        return true;
      }
      if (type === 'unsuitable' && this.unsuitableCount >= 1 && currentType !== 'unsuitable') {
        return true;
      }
      return false;
    },
    onSelectSuitable(answer) {
      const currentValue = this.selectedType[answer.id];
      if (currentValue === 'suitable') {
        this.$set(this.selectedType, answer.id, null);
      } else {
        if (this.suitableCount >= 2) {
          this.showToast('Можно выбрать не более 2 подходящих вариантов', 'warning');
          return;
        }
        this.$set(this.selectedType, answer.id, 'suitable');
      }
    },

    onSelectUnsuitable(answer) {
      const currentValue = this.selectedType[answer.id];

      if (currentValue === 'unsuitable') {
        this.$set(this.selectedType, answer.id, null);
        return;
      }

      if (currentValue === 'suitable') {
        this.$set(this.selectedType, answer.id, 'unsuitable');
        return;
      }

      if (this.unsuitableCount >= 1) {
        this.showToast('Можно выбрать только 1 неподходящий вариант', 'warning');
        return;
      }

      this.$set(this.selectedType, answer.id, 'unsuitable');
    },
    resetSelection() {
      this.selectedType = {};
      this.validationError = null;
    },
    async submitAnswers() {
      if (!this.isValidSelection) {
        this.showToast('Пожалуйста, выберите 2 подходящих и 1 неподходящий вариант', 'error');
        return;
      }
      const data = {
        id: this.testData.question.id,
        positive_choice_ids: this.suitableAnswers,
        negative_choice_ids: this.unsuitableAnswers,
      };

      try {
        await this.sendAnswer(data);
      } catch (error) {
        return error;
      }
    },

    showToast(message) {
      Vue.prototype.$toast.error(message, '', { position: 'topRight' });
    },

    preventCopy(e) {
      e.preventDefault();
      this.showToast('Копирование запрещено');
      return false;
    },

    preventContextMenu(e) {
      e.preventDefault();
      return false;
    },

    preventSelect(e) {
      e.preventDefault();
      return false;
    },

    applyGlobalProtection() {
      this.$el.addEventListener('copy', this.preventCopy);
      this.$el.addEventListener('contextmenu', this.preventContextMenu);
      this.$el.addEventListener('selectstart', this.preventSelect);
    }
  },
  mounted() {
    this.applyGlobalProtection();
  },
  beforeDestroy() {
    this.$el.removeEventListener('copy', this.preventCopy);
    this.$el.removeEventListener('contextmenu', this.preventContextMenu);
    this.$el.removeEventListener('selectstart', this.preventSelect);
  }
};
</script>

<style lang="scss" scoped>
.test-from-editor{
  & .list-item{
    -webkit-box-shadow: 0px 3px 25px -7px rgba(0, 144, 255, 0.2);
    -moz-box-shadow: 0px 3px 25px -7px rgba(0, 144, 255, 0.2);
    box-shadow: 0px 3px 25px -7px rgba(0, 144, 255, 0.2);
  }
}
</style>
